import gql from 'graphql-tag'

export const TaskStatusOptionsQuery = gql`query TaskStatusOptionsQuery {
    optionsList: __type(name: "TaskRabbitTaskRabbitStatusChoices") {
        enumValues {
            name
            description
        }
    }
}`

export const BoardQuery = gql`query Board($id: ID!){
    board(id: $id){
        id
        pk
        title
        description
        dateAdded
        owner {
            id
            username
            firstName
            lastName
        }
        sharedWithGroups {edges{node{id name}}}
        sharedWithUsers{edges{node{id pk name firstName lastName username}}}
        columnSet {
            edges {
                node {
                    id
                    pk
                    title
                    isArchived
                    columnType
                    allowedOptions
                    stateTransitions
                    contentType {
                        id
                        model
                    }
                }
            }
        }
    }
}`

export const AllColumnsQuery = gql`query AllColumnsQuery($boardId: ID!){
    allColumns(boardId: $boardId, isArchived: false){
        edges {
            node {
                id
                pk
                title
                isRequired
                columnType
                elementType
                allowedOptions
                stateTransitions
                contentType {
                    id
                    appLabel
                    model
                }
            }
        }
    }
}`

export const AllBoardsQuery = gql`query AllBoards($cursor: String, $orderBy:[String], $first: Int){
    allBoards(after: $cursor, orderBy: $orderBy, first: $first, isArchived: false){
        edges{
            cursor
            node{
                id
                pk
                title
                description
                dateAdded
                isArchived
                owner {
                    id
                    username
                    firstName
                    lastName
                }
            }
        }
        pageInfo{
            hasNextPage
            endCursor
        }
    }
    
}`


export const AllTasksQuery = gql`query AllTasks($orderBy:[String], $first: Int, $after: String, $assignedToIds: [ID], $statuses: [String], $boardIds: [ID], $searchTerm: String, $isArchived: Boolean, $incidentId: ID, $dueDateGte: String, $dueDateLte: String, $dueDateIsNull: Boolean){
    allTasks(orderBy: $orderBy, first: $first, after: $after, assignedToIds: $assignedToIds, statuses: $statuses, boardIds: $boardIds, searchTerm: $searchTerm, isArchived: $isArchived, incidentId: $incidentId, dueDateGte: $dueDateGte, dueDateLte: $dueDateLte, dueDateIsNull: $dueDateIsNull){
        edges{
            node{
                id
                pk
                dateAdded
                dateModified
                title
                description
                dueDate
                status
                commentsCount
                isArchived
                isAutomated
                taskcolumnvalueSet {
                    edges {
                        node {
                            id
                            value
                            grapheneId
                            valueString
                            column {
                                id
                                pk
                                title
                                columnType
                                contentType {
                                    id
                                    model
                                }
                            }
                        }
                    }
                }
                assignedTo{
                    edges {
                      node { 
                            id 
                            pk
                            username
                            firstName
                            lastName
                        }
                    }
                }
                board{
                    id
                    title
                }
                createdBy {
                    id
                    username
                    firstName
                    lastName
                }
            }
        }
        pageInfo{
            hasNextPage
            endCursor
            length
        }
    }
    
}`


export const TaskQuery = gql`query Task($id: ID!){
    task(id: $id){
        id
        title
        isAutomated
        description
        dateAdded
        dueDate
        status
        createdBy {id username firstName lastName }
        assignedTo {
            edges {
                node {
                    id
                    pk
                    username
                    firstName
                    lastName
                }
            }
        }
        board {
            id
            title
            columnSet {
                edges {
                    node {
                        id
                        pk
                        title
                        isArchived
                        columnType
                        allowedOptions
                        contentType {
                            id
                            model
                        }
                    }
                }
            }
        }
        taskcolumnvalueSet {
            edges {
                node {
                    id
                    value
                    valueString
                    grapheneId
                    column {
                        id
                        pk
                        columnType
                        contentType {
                            id
                            model
                        }
                    }
                }
            }
        }
        taskchecklistSet {
            edges {
                node {
                    id
                    title
                    description
                    mustComplete
                    completedOn
                }
          }
        }
        history{
            date
            comment
            user
        }
    }
}`


export const AllDriversQuery = gql`query AllDrivers($searchTerm: String){
    allDrivers(searchTerm: $searchTerm, first: 10){
        edges{
            node{ 
                id pk name branch{ id name }
            }
        }
    }
    
}`

export const CarsQuery = gql`query AllCars($searchTerm: String){
    allCars(searchTerm: $searchTerm, first: 10){
        edges{
            node{
                id pk vin customName make model year
            }
        }
    }
    
}`

export const RepsQuery = gql`
     query AllRepsQuery($groups:[String], $searchTerm: String, $permissions: [String]){
        allReps(searchTerm: $searchTerm, first: 10, isStaff:true, isActive:true, groups:$groups, orderBy:["username"], permissions: $permissions){
        edges{
          node{
            id
            name
            username
            firstName
            lastName
          }
        }
      }
    }
`

export const GroupsQuery = gql`
    query AllGroupsQuery($searchTerm: String){
        allGroups(name_Icontains: $searchTerm, first: 10){
            edges{
                node{
                    id
                    name
                }
            }
        }
    }
`

export const AllTaskCommentReactionsQuery = gql`query AllTaskCommentReactions($commentId: ID, $taskId: ID, $createdById: ID){
    allTaskCommentReactions(commentId: $commentId, taskId: $taskId, createdById: $createdById){
        edges{
            node{
                id
                reaction
                comment{ id }
                createdBy{
                    id
                    username
                    firstName
                    lastName
                }
            }
        }
    }
}`

export const AllIncidentsQuery = gql`query AllIncidents($searchTerm: String, $incidentId: ID){
    allIncidents(searchTerm: $searchTerm, id: $incidentId, first: 10, orderBy:["-id"]){
        edges{
            node{
                id 
                pk
                title
            }
        }
    }
}`

export const AllCarIssuesQuery = gql`query AllCarIssues($searchTerm: String){
    allCarIssues(searchTerm: $searchTerm, first: 10, orderBy:["-id"]){
        edges{
            node{
                id
                pk
                issueCategory {
                    id
                    category
                }
                car{
                    id
                    pk
                    year
                    make
                    model
                }
            }
        }
    }
}`


export const AllTaskCommentsQuery = gql`query allTaskComments($taskId: ID!) {
    allTaskComments(taskId: $taskId, isArchived: false) {
      edges {
        node {
          id
          dateAdded
          createdBy {
            id
            username
            firstName
            lastName
          }
          comment
          reactionsCount
          isArchived
          taskcommentattachmentSet {
            edges {
              node {
                id
                url
                extension
                name
              }
            }
          }
        }
      }
    }
  }
`;
